import React from 'react';
import { Truck, ShieldCheck, Sparkles } from 'lucide-react';

const items = [
  { icon: Truck, text: 'Free shipping over \u20b91,999' },
  { icon: ShieldCheck, text: 'Cash on Delivery available' },
  { icon: Sparkles, text: 'Handcrafted luxury decor' },
  { icon: Truck, text: 'Easy 7-day returns' },
];

export const AnnouncementBar = () => (
  <div className="overflow-hidden bg-[hsl(var(--gaze-green-bottle))] text-[hsl(var(--primary-foreground))]">
    <div className="flex whitespace-nowrap py-2 animate-marquee">
      {[...items, ...items, ...items, ...items].map((it, i) => (
        <span key={i} className="mx-6 inline-flex items-center gap-2 text-[11px] font-medium tracking-wide">
          <it.icon size={13} className="gaze-gold" /> {it.text}
        </span>
      ))}
    </div>
  </div>
);

export default AnnouncementBar;
